module.exports = __webpack_public_path__ + "img/exam_jan_2025_jb8sdo06.ed073337.jpg";